import apiClient from 'utilities/apiClient';

export const create_hvac_label = (payload) => {
  return apiClient.post(`${apiClient.Urls.hvacFilters}`, payload, true);
};

export const regenerate_missing_hvac_pdfs = () => {
  return apiClient.post(
    `${apiClient.Urls.hvacFilters}/regenerate-missing`,
    {},
    true
  );
};

export const get_hvac_labels = (payload) => {
  return apiClient.get(`${apiClient.Urls.hvacFilters}`, payload, true);
};

export const get_hvac_label = (id) => {
  return apiClient.get(`${apiClient.Urls.hvacFilters}/${id}`, {}, true);
};

export const get_hvac_counts = () => {
  return apiClient.get(`${apiClient.Urls.hvacFilters}/counts`, {}, true);
};

export const get_hvac_logs = (hvacLabelNumber) => {
  return apiClient.get(
    `${apiClient.Urls.hvacFilters}/${hvacLabelNumber}/logs`,
    {},
    true
  );
};

export const get_hvac_areas = () => {
  return apiClient.get(`${apiClient.Urls.hvacFilters}/areas`, {}, true);
};

export const bulk_send_for_cleaning = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.hvacFilters}/bulk-send-cleaning`,
    payload,
    true
  );
};

export const bulk_mark_cleaned_and_assign = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.hvacFilters}/bulk-mark-cleaned-and-assign`,
    payload,
    true
  );
};

export const bulk_install_from_spare = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.hvacFilters}/bulk-install-from-spare`,
    payload,
    true
  );
};

export const bulk_inactivate_hvac = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.hvacFilters}/bulk-inactivate`,
    payload,
    true
  );
};

export const reactivate_hvac = (hvacLabelNumber, payload) => {
  return apiClient.post(
    `${apiClient.Urls.hvacFilters}/${hvacLabelNumber}/reactivate`,
    payload,
    true
  );
};

export const generate_hvac_usage_log_report = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.hvacFilters}/usage-log-report`,
    payload,
    true
  );
};
